<template>
  <el-card shadow="never">
    <template slot="header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: $root.getDashboardPath() }">Dashboard</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'Facility Finance' }">Finance</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'Facility Finance sales'}">{{ $root.getHeader() }} Finance Sales Tax</el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <el-card shadow="never">
      <template slot="header">
        <el-date-picker
          v-model="date"
          type="month"
          placeholder="Pick a month"
          @change="getSalesTaxData"
        >
        </el-date-picker>
        <el-button @click="getItemsForCSV" :disabled="loading">
          Export
        </el-button>
      </template>
      <el-card
          :body-style="{background: 'linear-gradient(35deg, #009aca, #0c3da7)', padding: '20px' }"
          v-loading="loading"
          shadow="never"
        >
        <div slot="header">
          <h4 class="head">Sales Tax</h4>
        </div>
        <div>
          <h4 class="body">
            {{ salesTax | currencySign($root.state.facilityData) }}
          </h4>
        </div>
      </el-card>
      <br />
      <el-card shadow="never">
        <el-table :data="facilitySalesTax" v-loading="loading">
          <el-table-column :width="300" label="Details" prop="description"></el-table-column>
          <el-table-column label="Customer" prop="company"></el-table-column>
          <el-table-column label="Period" prop="period"></el-table-column>
          <el-table-column label="Type">
            <template>
              Rent
            </template>
          </el-table-column>
          <el-table-column label="Amount">
            <template slot-scope="scope">
              <div v-if="scope.row.amount">
                 {{ scope.row.amount | currencySign($root.state.facilityData) }}
              </div>
              <div v-else>
                  -
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </el-card>
  </el-card>
</template>

<script>
import axios from 'axios';
import getMonthAndYear from '../utils/timing';
import { CUSTOMER_API_BASE } from '../env';
import { exportToCsvV2, saveCsv } from '../utils/exportToCsv';

export default {
  name: 'FinanceDeposits',
  props: {
    facility: { type: String, required: true },
  },
  watch: {
    async facility() {
      this.loading = true;
      await this.getSalesTaxData();
      this.loading = false;
    },
  },
  async mounted() {
    this.loading = true;
    await this.getSalesTaxData();
    this.loading = false;
  },
  computed: {
    salesTax() {
      return this.totalSalesTax;
    },
  },
  data() {
    return {
      facilitySalesTax: [],
      totalSalesTax: 0,
      loading: true,
      date: new Date(),
    };
  },
  methods: {
    getItemsForCSV() {
      const salesTaxItemsCsv = exportToCsvV2({
        description: 'Description',
        company: 'Customer',
        period: 'Period',
        amount: 'Amount',
      }, this.facilitySalesTax);

      saveCsv(salesTaxItemsCsv, `Sales_Tax_Report_${getMonthAndYear(this.date)}`);
    },
    async getSalesTaxData() {
      if (!this.$root.state.facility) {
        return;
      }
      this.loading = true;
      const response = await axios.get(`${CUSTOMER_API_BASE}/customers/v1/facility/${this.$root.state.facility}/sales/tax`, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
        params: {
          ...( this.date ? { month: this.date.getMonth(), year: this.date.getFullYear() } : {})
        }
      });

      this.facilitySalesTax = response.data.result.finalTaxItems.map(item => ({
        ...item,
        description: item.description.replace(/,/g, ''),
        period: getMonthAndYear(item.period).replace(/,/g, ''),
      }));
      this.totalSalesTax = response.data.result.taxAmount;

      this.loading = false;
    },
  },
};
</script>

<style scoped>
.body {
  color: #efefef;
  font-weight: 300;
}

.head {
  font-weight: 400;
  margin: 0;
  color: #009aca;
}
</style>



// WEBPACK FOOTER //
// src/components/FinanceSalesTax.vue